// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/PlatformWebhooks_SubscriptionDeleteInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/** POST /platform-webhooks/subscription-delete */
import { registerContract } from './validate'

export interface PlatformWebhooks_SubscriptionDeleteInput {
id: number
}

registerContract('PlatformWebhooks_SubscriptionDeleteInput', {
  id: { type: 'number',  required: true },
})
